import fetchClient from "api/client";
import { stringify } from "qs";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";
import INSIGHTS_ENDPOINT from "./insightsEndpoint";
/**
 * @description GET api/insights/search
 * */
export default async function getInsightsData({
  search,
  aiLogic,
  page,
  perPage,
  sortBy,
  sortDir,
  partnerId,
  brandIds,
  excludeBrandIds,
  categoryId,
  insightful,
  tags,
  keywords,
  sentiments,
}) {
  if (!search) {
    const queryString = stringify(
      {
        page: page || 0,
        sortBy,
        sortDir,
        partnerId,
        brandIds,
        excludeBrandIds,
        categoryId,
        insightful,
        tags,
        keywords,
        sentiments,
        ...getPerPageQueryParam(perPage),
      },
      { addQueryPrefix: true },
    );

    const response = await fetchClient.get(`${INSIGHTS_ENDPOINT}${queryString}`);
    const sanitizedData = response.data.map((item) => ({
      ...item,
      tags: (item.tags || []).filter((t) => t !== "none"),
    }));
    return { ...response, data: sanitizedData };
  }

  const response = await fetchClient.post(`${INSIGHTS_ENDPOINT}/search`, {
    body: {
      search,
      aiLogic,
      page,
      perPage,
      sortBy,
      sortDir,
      partnerId,
      brandIds,
      excludeBrandIds,
      categoryId,
      insightful,
      tags,
      keywords,
      sentiments,
    },
  });
  const sanitizedData = response.data.map((item) => ({
    ...item,
    tags: (item.tags || []).filter((t) => t !== "none"),
  }));

  return { ...response, data: sanitizedData };
}
